import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";

export const ModalTitle = styled.div`
    font-size: ${FontSizeInPx.LARGE}px;
    font-weight: 600;
    line-height: ${LineHeightInPx.LARGE}px;
`;
export const containerStyles = css`
    padding: ${Spacing["2XS"]}px ${Spacing.LG}px ${Spacing.LG}px;
`;
export const ModalDescription = styled.div`
    margin-bottom: ${Spacing.MD}px;
    font-size: ${FontSizeInPx.REGULAR}px;
    line-height: ${LineHeightInPx.REGULAR}px;
`;
export const formStyles = css`
    padding: ${Spacing.MD}px;
    border: 1px solid ${Colors.Gray.V100};
    border-radius: ${Spacing["2XS"]}px;
`;
